import window from '../injectChromeObject'
import { normalizeGDocsUrl } from './normalizeGDocsUrl'

export async function getContainingUrlFromActiveTab(useFallback = true) {
  const tabs = await window.chrome?.tabs?.query({
    active: true,
    currentWindow: true
  })

  const gotTabUrl = tabs && tabs.length > 0 && Boolean(tabs[0].url)

  let url = gotTabUrl ? tabs[0].url : window.location.href

  url = normalizeGDocsUrl(url)

  return gotTabUrl || useFallback ? url : null
}
